import { Navigate } from "react-router-dom";
import type { ChatTurnProps } from "../../types/chat";
import { getKycFailedScreen } from "./kycFailedScreen";

export function KycFailedTurn(props: ChatTurnProps) {
  return <Navigate to={getKycFailedScreen(props)} replace />;
}
